import { Button, Flex, Text } from '@backstage/ui';
import {
  RELATION_PATCH_PLAY_HAND_HINT,
  RELATION_PATCH_PLAY_HAND_LABEL,
  RELATION_PATCH_PLAY_WINDOW_HINT,
  RELATION_PATCH_PLAY_WINDOW_LABEL,
} from './gameCopy';
import type { ControlMode } from './types';
import styles from './GraphRunnerGame.module.css';

type PlayModeButtonsProps = {
  onModeSelect: (mode: ControlMode) => void;
  disabled?: boolean;
};

export function PlayModeButtons({
  onModeSelect,
  disabled = false,
}: PlayModeButtonsProps) {
  return (
    <Flex
      direction="column"
      gap="3"
      className={styles.playModeButtons}
      role="group"
      aria-label="Choose control mode"
    >
      <Button
        variant="secondary"
        className={styles.playModeButton}
        isDisabled={disabled}
        onPress={() => onModeSelect('hand')}
      >
        <Flex direction="column" align="start" gap="1">
          <Text weight="bold">{RELATION_PATCH_PLAY_HAND_LABEL}</Text>
          <Text variant="body-small">{RELATION_PATCH_PLAY_HAND_HINT}</Text>
        </Flex>
      </Button>
      <Button
        variant="secondary"
        className={styles.playModeButton}
        isDisabled={disabled}
        onPress={() => onModeSelect('window')}
      >
        <Flex direction="column" align="start" gap="1">
          <Text weight="bold">{RELATION_PATCH_PLAY_WINDOW_LABEL}</Text>
          <Text variant="body-small">{RELATION_PATCH_PLAY_WINDOW_HINT}</Text>
        </Flex>
      </Button>
    </Flex>
  );
}
